export { IncrementalSource } from './domain/record';
export var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
};
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-rum/esm/types.js
// module id = 577
// module chunks = 0